var ref = require("prosemirror-transform");
var Mapping = ref.Mapping;

var TrackedRecord = function(prev, mapping, state) {
  this.prev = prev
  this.mapping = mapping
  this.state = state
};

var TrackMappings = function(state) {
  this.seen = [new TrackedRecord(null, null, state)]
};

TrackMappings.prototype.find = function (state) {
    var this$1 = this;

  for (var i = this.seen.length - 1; i >= 0; i--) {
    var record = this$1.seen[i]
    if (record.state == state) { return record }
  }
};

TrackMappings.prototype.track = function (old, action, state) {
  var found = this.seen.length < 200 ? this.find(old) : null
  if (found)
    { this.seen.push(new TrackedRecord(found, action.type == "transform" ? action.transform.mapping : null, state)) }
};

TrackMappings.prototype.getMapping = function (state) {
  var found = this.find(state)
  if (!found) { return null }
  var mappings = []
  for (var rec = found; rec; rec = rec.prev)
    { if (rec.mapping) { mappings.push(rec.mapping) } }
  var result = new Mapping
  for (var i = mappings.length - 1; i >= 0; i--)
    { result.appendMapping(mappings[i]) }
  return result
};
exports.TrackMappings = TrackMappings



//////////////////
// WEBPACK FOOTER
// ../~/prosemirror-view/dist/trackmappings.js
// module id = 349
// module chunks = 0